import React from "react";
import PropTypes from "prop-types";
import FormFieldGrid from "./FormFieldGrid";
import { TimePicker } from "@mui/x-date-pickers";
import { parse } from "date-fns";

function FormTimePickerHoursMinutes(props) {
  return (
    <FormFieldGrid
      {...props}
      Field={TimePicker}
      fieldProps={({ value, onChange }) => ({
        onChange: (value) => {
          onChange(value.toLocaleTimeString());
        },
        ampm: false,
        views: ["hours", "minutes"],
        value: parse(value, "HH:mm:00", new Date()),
      })}
    />
  );
}

FormTimePickerHoursMinutes.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  textFieldType: PropTypes.string,
  timeFormat: PropTypes.string,
  dateFormat: PropTypes.string,
  outputFormat: PropTypes.string,
};

FormTimePickerHoursMinutes.defaultProps = {
  textFieldType: "text",
  timeFormat: "HH:mm:00",
  dateFormat: "DD-MM-YYYY",
  outputFormat: "YYYY-MM-DD HH:mm:00",
};

export default FormTimePickerHoursMinutes;
